import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { GET_USER_PROFILE_MESSAGE_TYPE } from '@leagueplatform/user-profile-api';

// Returns a stable callback that marks the user-profile query stale,
// triggering a background refetch for any subscribed component. Used
// from mutation `onSuccess` handlers so server writes that change the
// user profile (consent flags, marketing preference, mobile-verified
// flag, personal info, etc.) keep the cache fresh for downstream
// consumers without each mutation re-implementing the queryKey lookup.
export const useInvalidateUserProfile = () => {
  const queryClient = useQueryClient();
  return useCallback(
    () =>
      queryClient.refetchQueries({
        queryKey: [GET_USER_PROFILE_MESSAGE_TYPE],
      }),
    [queryClient],
  );
};
